<template>
  <div class="main-header">
    <div class="main-header__overlay"></div>
    <div class="header-shadow">
      <a href="#main-content" class="skipto">
        <span class="skipto__text">Skip to content</span>
      </a>
      <div class="main-header__wrapper">
        <div class="main-header__hamburger">
          <button
            @click="burger()"
            aria-expanded="true"
            class="main-header__clickable main-header__trigger"
            :class="{ 'is-active': showMobile }"
          >
            <span class="top"></span> <span class="center1"></span>
            <span class="center2"></span> <span class="bottom"></span>
            <div class="is-sr-only">Toggle Menu</div>
          </button>
        </div>

        <nav class="main-header__links">
          <!--mobile-->
          <div
            :class="[
              'main-header__mobile',
              { 'main-header__mobile--open': showMobile },
            ]"
          >
            <a target="_blank" style="padding: 0px; display: block">
              <div
                class="header-mobile-banner"
                style="background-image: url('')"
              >
                <div class="header-mobile-banner__content">
                  <div>
                    <p class="header-mobile-banner__content__title">
                      <b></b>
                    </p>
                    <p class="header-mobile-banner__content__subtitle"></p>
                  </div>
                  <p class="header-mobile-banner__content__cta"></p>
                </div>
              </div>
            </a>
            <ul class="categories">
              <li
                v-for="(category, index) in leftSideLinks"
                :key="index"
                class="categories__item"
                @click="openMenu(category.id, true)"
                :class="[
                  {
                    'categories__item--with-sub':
                      category.subcategories && category.subcategories.length,
                  },
                ]"
              >
                <div v-if="category.href">
                  <a
                    :href="category.href"
                    :id="category.label"
                    @click.prevent="close()"
                  >
                    {{ category.label }}
                  </a>
                </div>
                <div v-else>
                  <button
                    :id="category.id"
                    :aria-expanded="isExpanded(category.id, true)"
                    :aria-controls="'panel-' + category.id"
                  >
                    {{ category.label }}
                  </button>
                  <categories
                    :isMobileView="true"
                    :subcategories="category.subcategories"
                    :categoryId="category.id"
                    :customLink="category.customLink"
                    v-if="category.subcategories"
                  />
                </div>
              </li>
            </ul>
            <ul class="categories right-stuff">
              <li
                v-for="(category, index) in rightSideLinks"
                :key="index"
                class="categories__item"
                :class="[
                  {
                    'categories__item--with-sub':
                      category.subcategories && category.subcategories.length,
                  },
                ]"
                @click="openMenu(category.id, true)"
                id="mobileCategoryBorder"
              >
                <div v-if="category.href">
                  <a
                    :href="category.href"
                    :id="category.label"
                    @click.prevent="close()"
                  >
                    {{ category.label }}
                  </a>
                </div>
                <div v-else>
                  <button
                    :id="category.id"
                    :aria-expanded="isExpanded(category.id, true)"
                    :aria-controls="'panel-' + category.id"
                  >
                    {{ category.label }}
                  </button>
                  <categories
                    :isMobileView="true"
                    :subcategories="category.subcategories"
                    :categoryId="category.id"
                    :customLink="category.customLink"
                    v-if="category.subcategories"
                  />
                </div>
              </li>
            </ul>

            <div
              class="header-panel__wrapper container--full"
              v-if="!searchShow"
              id="socialList"
            >
              <header-link>
                <ul>
                  <slot
                    name="headerSocialIcons"
                    :open="openMenu"
                    :close="closeMenuBeforeFollow"
                    :is-expanded="isExpanded"
                    :active-panel="activePanel"
                    :small-screen="smallScreen"
                  />
                </ul>
              </header-link>
            </div>
          </div>

          <!--desktop left side-->
          <div class="header-links--primary">
            <ul class="categories">
              <li
                v-for="(category, index) in leftSideLinks"
                :key="index"
                class="categories__item categories__item--with-sub"
                :class="
                  activePanel == category.id ? 'categories__item--active' : ''
                "
                @click="openMenu(category.id, false)"
              >
                <div v-if="category.href">
                  <a
                    :href="category.href"
                    :id="category.label"
                    @click.prevent="close()"
                  >
                    {{ category.label }}
                  </a>
                </div>
                <div v-else>
                  <button
                    :id="category.id"
                    :aria-expanded="isExpanded(category.id, false)"
                    :aria-controls="'panel-' + category.id"
                    :class="activePanel == category.id ? 'active-menu' : ''"
                  >
                    {{ category.label }}
                  </button>
                  <categories
                    v-if="activePanel == category.id"
                    :subcategories="category.subcategories"
                    :categoryId="category.id"
                    :customLink="category.customLink"
                    :isMobileView="false"
                  />
                </div>
              </li>

              <div
                v-if="activePanel == 'id-followus-123'"
                :class="[
                  'header-panel',
                  { 'header-panel--open': activePanel },
                  { 'primary-header': shouldIHideRightBlock },
                ]"
              >
                <div
                  class="header-panel__wrapper container--full"
                  v-if="!searchShow"
                  id="socialList"
                >
                  <div class="header-link--tagging">
                    <ul>
                      <slot
                        name="headerSocialIcons"
                        :open="openMenu"
                        :close="closeMenuBeforeFollow"
                        :is-expanded="isExpanded"
                        :active-panel="activePanel"
                        :small-screen="smallScreen"
                      />
                    </ul>
                  </div>
                </div>
              </div>
            </ul>
          </div>

          <!--logo-->
          <div class="main-header__clickable">
            <slot name="logo" />
          </div>

          <!--desktop right side-->
          <div class="header-links--secondary">
            <ul class="categories right-stuff">
              <li
                v-for="(category, index) in rightSideLinks"
                :key="index"
                class="categories__item categories__item--with-sub"
                :class="
                  activePanel == category.id ? 'categories__item--active' : ''
                "
                @click="openMenu(category.id, false)"
              >
                <div v-if="category.href">
                  <a
                    :href="category.href"
                    :id="category.label"
                    @click.prevent="close()"
                  >
                    {{ category.label }}
                  </a>
                </div>
                <div v-else>
                  <button
                    :id="category.id"
                    :aria-expanded="isExpanded(category.id, false)"
                    :aria-controls="'panel-' + category.id"
                    :class="activePanel == category.id ? 'active-menu' : ''"
                  >
                    {{ category.label }}
                  </button>

                  <categories
                    v-if="activePanel == category.id"
                    :subcategories="category.subcategories"
                    :categoryId="category.id"
                    :customLink="category.customLink"
                    :isMobileView="false"
                  />
                </div>
              </li>
              <div
                v-if="activePanel == 'id-followus-123'"
                :class="[
                  'header-panel',
                  { 'header-panel--open': activePanel },
                  { 'primary-header': shouldIHideRightBlock },
                ]"
              >
                <div
                  class="header-panel__wrapper container--full"
                  v-if="!searchShow"
                  id="socialList"
                >
                  <header-link>
                    <ul class="header-posts" id="socialListPosts">
                      <slot
                        name="headerSocialIcons"
                        :open="openMenu"
                        :close="closeMenuBeforeFollow"
                        :is-expanded="isExpanded"
                        :active-panel="activePanel"
                        :small-screen="smallScreen"
                      />
                    </ul>
                  </header-link>
                </div>
              </div>
            </ul>
          </div>
        </nav>

        <div class="main-header__right">
          <slot
            name="control"
            :searchToggle="searchToggle"
            :is-expanded="isExpanded"
            :active-panel="activePanel"
          />
        </div>
      </div>
    </div>
    <div
      class="main-header__subcategories-menu"
      v-if="activePanel == 'id-search-123'"
    >
      <div class="header-panel header-panel--open">
        <slot name="panelSearch" :active-panel="activePanel" />
      </div>
    </div>
    <div class="main-header__subcategories-menu" v-if="!searchShow">
      <div
        id="rightPanel"
        :class="[
          'header-panel',
          { 'header-panel--open': activePanel },
          { 'primary-header': shouldIHideRightBlock },
        ]"
      >
        <div class="header-panel__wrapper container--full" id="rightWrapper">
          <slot name="panel" :activePanel="activePanel" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { scrollPosition, throttle } from '@Foundation/utilities';
  import Categories from './Categories.vue';
  import HeaderLink from '@/Feature/HeaderLink/code/Scripts/components/HeaderLink/HeaderLink.vue';

  export default {
    components: { Categories, HeaderLink },
    props: {
      leftSideLinks: { type: Array, default: () => [] },
      rightSideLinks: { type: Array, default: () => [] },
      logo: { type: Object, default: undefined },
    },
    data() {
      return {
        activeMobile: null,
        preserveOpened: false,
        activePanel: null,
        searchShow: false,
        hideRightBlock: false,
        body: null,
        overflowClass: 'body-hide-overflow',
        smallScreen: !window.matchMedia('(min-width: 1336px)').matches,
        showMobile: false,
      };
    },
    computed: {
      shouldIHideRightBlock() {
        return this.hideRightBlock;
      },
    },
    mounted() {
      this.body = document.querySelector('body');
      this.scrollEventAdd();
      this.updateSmallScreenOnResize();
    },
    methods: {
      closeMenuBeforeFollow(event) {
        this.burger();
        setTimeout(() => {
          window.location.href = event.target.href;
        }, 300);
      },
      burger() {
        this.searchShow = this.setValueIfTrue(this.searchShow, false);
        this.activePanel = null;
        this.toggleMobile();
        this.overlayToggle(this.showMobile);
      },
      searchToggle(id) {
        this.toggleSearch();
        this.showMobile = this.setValueIfTrue(this.showMobile, false);
        if (this.searchShow) {
          this.overlayToggle(true);
          this.preserveOpened = true;
          this.activePanel = id;
          this.focusSearchBar();
        } else {
          this.overlayToggle(false);
          this.activePanel = null;
        }
      },
      toggleSearch() {
        this.searchShow = !this.searchShow;
      },
      toggleMobile() {
        this.showMobile = !this.showMobile;
      },
      focusSearchBar() {
        this.$nextTick(() => {
          const searchField = document.getElementById('search-field');
          if (!searchField) {
            return;
          }
          searchField.focus();
        });
      },
      setValueIfTrue(condition, val) {
        return condition ? val : condition;
      },
      openMenu(id, isSmallScreen) {
        if (isSmallScreen) {
          this.handleAccordion(id);
          return;
        }
        this.preserveOpened = true;
        this.activePanel = id;
        this.overlayToggle(true);
        this.searchShow = false;

        const linkItem = this.$el.querySelector(`[id='${id}']`);

        if (linkItem && linkItem.closest('.header-links--primary')) {
          this.hideRightBlock = true;
        } else {
          this.hideRightBlock = false;
        }
      },
      close() {
        if (this.smallScreen) {
          this.activeMobile = null;
          return;
        }
        if (!this.preserveOpened) {
          this.activePanel = null;
          this.overlayToggle(false);
          this.searchShow = false;
        }
        setTimeout(() => {
          this.preserveOpened = false;
        }, 100);
      },
      closeOnEsc() {
        return this.activePanel ? this.close() : null;
      },
      isExpanded(id, isSmallScreen) {
        const active = isSmallScreen ? this.activeMobile : this.activePanel;
        return id === active ? 'true' : 'false';
      },
      handleAccordion(id) {
        this.activeMobile = id;

        const elemClass = 'categories__item--open';
        const elem = document.getElementById(id);

        if (!elem) {
          return;
        }

        const panelElem = document.getElementById(`panel-${id}`);
        const parentElem = elem.closest('.categories__item');

        const parentActive = parentElem.classList.contains(elemClass);

        /* istanbul ignore next */
        if (!parentActive) {
          this.collapseAll(elemClass);
          this.updateAriaHidden();
        }

        parentElem.classList.toggle(elemClass);
        panelElem.setAttribute('aria-hidden', parentActive);
        elem.setAttribute('aria-expanded', !parentActive);
      },
      collapseAll(elemClass) {
        const categories = document.querySelectorAll('.categories__item');
        /* istanbul ignore next */
        Array.prototype.forEach.call(categories, function (item) {
          item.classList.remove(elemClass);
        });
      },
      updateAriaHidden() {
        const subcategories = document.querySelectorAll('.subcategories');
        /* istanbul ignore next */
        Array.prototype.forEach.call(subcategories, function (item) {
          item.setAttribute('aria-hidden', true);
        });
      },

      /**
       * Open or close the overlay
       * Apply a class to the body to enable scrolling
       * @param {boolean} show - True to open, false to close
       * @returns {undefined}
       */
      overlayToggle(show) {
        this.overlayShow = show;

        /* istanbul ignore next */
        if (show) {
          this.body.classList.add(this.overflowClass);
        } else {
          this.body.classList.remove(this.overflowClass);
        }
      },

      /**
       * Handles showing or hiding the bar when scrolling
       * @param {number} scrollPos - Scroll position on time of request
       * @returns {number} Current scroll position
       */
      scrollEventHandle(scrollPos) {
        if (!this.$refs.mainMenu || this.showMobile) {
          return null;
        }
        const body = document.querySelector('body');
        const classnames = {
          sticky: 'is-sticky',
          stickyHidden: 'is-sticky--hidden',
        };
        const navHeight = this.$refs.mainMenu.getBoundingClientRect().height;
        const currentScrollPos = scrollPosition();
        const isScrollingDown = currentScrollPos > scrollPos;
        if (!isScrollingDown && currentScrollPos > navHeight) {
          this.$refs.mainMenu.classList.add(`${classnames.sticky}`);
          this.$refs.mainMenu.classList.remove(`${classnames.stickyHidden}`);
          body.style.paddingTop = `${navHeight}px`;
          this.$root.$emit('menu-hidden', false);
        } else if (isScrollingDown && currentScrollPos > navHeight) {
          this.$refs.mainMenu.classList.add(`${classnames.stickyHidden}`);
          this.$root.$emit('menu-hidden', true);
        } else {
          this.$refs.mainMenu.classList.remove(`${classnames.sticky}`);
          this.$refs.mainMenu.classList.remove(`${classnames.stickyHidden}`);
          body.style.paddingTop = 0;
        }

        return currentScrollPos;
      },

      /**
       * Setup event listener for scrolling (required for sticky bar)
       * @returns {undefined}
       */
      scrollEventAdd() {
        let scrollPos = scrollPosition();
        window.addEventListener(
          'scroll',
          throttle(() => {
            scrollPos = this.scrollEventHandle(scrollPos);
          }, 160)
        );
      },

      /**
       * Event listener for keeping smallScreen current if screen size changes
       * @returns {true or false}
       */
      updateSmallScreenOnResize() {
        /* istanbul ignore next */
        window.addEventListener(
          'resize',
          throttle(() => {
            this.smallScreen = !window.matchMedia('(min-width: 1336px)')
              .matches;
          }, 100)
        );
      },
    },
  };
</script>

<style>
  /* @import "../../../../../../../build/Website/themes/MDC/css/bundle.css"; */
  @media screen and (min-width: 1024px) and (max-width: 1250px) {
    .main-header .categories a,
    .main-header .categories button {
      font-size: 12px !important;
    }
  }
  /* .sdc .main-header__mobile {
  top: 1.625rem !important;
} */
  .header-links--primary .categories .image-link-grid,
  .header-links--primary .categories .subcategories,
  .header-links--secondary .categories .image-link-grid,
  .header-links--secondary .categories .subcategories {
    display: flex;
  }
  .main-header__wrapper {
    max-width: 100% !important;
  }
  .post-hightlight .header-posts__image {
    max-height: 15.5rem;
  }
  .header-posts li {
    /* display: flex;
  flex-direction: column;
  justify-content: start;*/
    margin: 0 0 10px 0 !important;
  }
  .post-hightlight .title {
    visibility: hidden;
  }

  .main-header__links {
    max-width: 1515px;
    /* justify-content: space-evenly;*/
    margin: 0 auto;
  }
  .header-links--primary .categories li:not(:last-child),
  .header-links--secondary .categories li:not(:last-child) {
    margin-right: 0.9375rem !important;
    align-items: start;
  }
  .header-links--primary .categories li {
    align-items: baseline;
  }
  .header-links--primary .categories li,
  .header-links--secondary .categories li {
    align-items: start !important;
  }
  .sdc .title {
    margin: 0 !important;
  }
  .main-header .main-header__mobile .categories {
    display: block;
  }
  .main-header__subcategories-menu {
    padding: 0 0%;
  }
  .image-link {
    margin-right: 2.813rem !important;
  }

  @media screen and (min-width: 1024px) {
    /* .header-panel__wrapper container--full{
    width: 90%;
  } */
    .social-icon-list {
      margin: auto;
    }
    .social-icon-list ul {
      display: block !important;
      flex-direction: column !important;
    }
    .header-panel--open {
      border-bottom: none !important;
    }
    #socialList {
      justify-content: end !important;
    }
  }
  @media screen and (min-width: 60.5rem) {
    .header-posts .social-icon-list {
      display: block !important;
    }
    .social-icon-list li .label {
      display: inline-block !important;
    }
    /* .social-icon-list li img.icons {
    display: none!important;
  } */
  }

  .social-icon-list {
    padding: 0;
  }

  @media screen and (max-width: 1023px) {
    #socialList {
      display: flex;
      justify-content: start;
      max-width: 537px;
      padding: 0;
    }
    .social-icon-list ul {
      width: 350px;
      display: flex;
      flex-wrap: nowrap;
      flex-direction: row !important;
      justify-content: space-around;
    }
  }
  .header-posts__recent .item .title {
    font-size: 0.7375rem;
    font-weight: 500;
    letter-spacing: 1px;
  }
  #socialListPosts {
    border-left: 1px solid #ccc;
    margin: auto;
  }
  .main-header__mobile #id-followus-123 {
    display: block;
  }

  ul li:nth-child(6):before {
    display: none;
  }
  .categories__item--with-sub li {
    display: flex;
    flex-direction: column;
  }
  .main-header__mobile .categories__item--with-sub {
    position: sticky;
    border: 0;
  }
  #mobileCategoryBorder {
    border-top: 1px solid var(--color-grey-medium);
  }
  .social-icon-list .follow-us-text {
    display: none !important;
    /* width: 100%; */
  }
  .main-header .categories a,
  .main-header .categories button {
    position: relative;
  }
  @media screen and (min-width: 48rem) {
    .main-header .categories .active-menu::after,
    .main-header .categories .button:hover,
    .main-header .categories .active-menu:hover::after {
      border-bottom: 1px solid black;
    }
  }
  @media (min-width: 83.5rem) {
    .main-header .categories button.active-menu::after {
      height: 1px;
    }
  }

  @media screen and (min-width: 1024px) {
    #rightPanel {
      width: 100%;
      position: absolute;
    }
    #rightWrapper {
      padding-left: 537px;
      width: 100%;
      float: left;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      flex-direction: row;
      height: auto;
    }
  }
  .header-posts a {
    padding: 0 10px;
  }
</style>
